import helper from '@main/externals/bss-package-helper/js/helper';
import EventManager from '@main/externals/bss-package-event-manager/js/event-manager';
import Formatter from '@main/externals/bss-package-formatter/js/formatter';
import { BSSBackendConnector } from '@main/core/bss-connector/backend-connector';
import { toolbox } from '@main/externals/bss-package-toolbox/js/toolbox';
import Resolutions from '@main/externals/bss-package-resolutions/js/resolutions';
import { parseRequest } from './js/parse-request';
import logger from '@main/externals/bss-package-logger/js/logger';
var BASE_PUBLISHER_NAME = 'bss-connector';
var HIDDEN_CLASS = 'bss-entity--is-hidden';
var BaseControllerToolbox = /** @class */ (function () {
    /**
     * @desc BSSControllerToolbox constructor
     * @param {String} [environment=null] environment
     * @param {Object} [resolutionsConfig=null] resolutionsConfig
     * @param {String} [version='prod'] version
     * @param {Object} [components=null] contains components
     * @param {Object} [descriptionConfig=null] contains // { [elementType]: { uiDescription, taggingDescription, tagging } },
     * @param {Object} [flowProps=null] contains flowProps like brand, country, lang
     * @param {Function} [setFlowConfigurationCallback=null] sets flowId in controller
     * @param {string} [insideWidgetQuoteId=null] contains quoteId
     * @param {Function} [setInsideWidgetQuoteIdCallback=null] sets quoteId in controller
     * @param {string} [theme=null] sets theme in controller
     * @param {Function} [origin=null] sets origin in controller
     * @param {Boolean} [isLocaleAphelia=null] sets aphelia for local purposes in controller
     * @param {Boolean} [standalone=null] standalone cf
     */
    function BaseControllerToolbox(environment, resolutionsConfig, version, components, descriptionConfig, flowProps, setFlowConfigurationCallback, insideWidgetQuoteId, setInsideWidgetQuoteIdCallback, isWidgetInWidget, isCompareFinance, theme, origin, isLocaleAphelia, initConfiguration, standalone) {
        if (environment === void 0) { environment = null; }
        if (resolutionsConfig === void 0) { resolutionsConfig = null; }
        if (version === void 0) { version = 'prod'; }
        if (components === void 0) { components = null; }
        if (descriptionConfig === void 0) { descriptionConfig = null; }
        if (flowProps === void 0) { flowProps = null; }
        if (setFlowConfigurationCallback === void 0) { setFlowConfigurationCallback = null; }
        if (insideWidgetQuoteId === void 0) { insideWidgetQuoteId = null; }
        if (setInsideWidgetQuoteIdCallback === void 0) { setInsideWidgetQuoteIdCallback = null; }
        if (isWidgetInWidget === void 0) { isWidgetInWidget = null; }
        if (isCompareFinance === void 0) { isCompareFinance = false; }
        if (theme === void 0) { theme = null; }
        if (origin === void 0) { origin = null; }
        if (isLocaleAphelia === void 0) { isLocaleAphelia = null; }
        if (initConfiguration === void 0) { initConfiguration = null; }
        if (standalone === void 0) { standalone = null; }
        helper.setCustomType({
            EventManager: EventManager,
            Formatter: Formatter,
            Resolution: Resolutions,
            Map: Map,
        });
        this.version = version;
        this._validateFlowProps(flowProps, standalone);
        this._flowConfigUrl = "".concat(process.env.ENV_URL, "/dispatcher/flow/");
        /**
         * product type for widget in widget integration
         * @type {string}
         * @public
         */
        this.productType = '';
        /**
         * private url for displaying images from ui-description
         * @type {string}
         * @public
         */
        this._privateUrl = '';
        /**
         * is compare finance flag
         * @type {Boolean}
         * @private
         */
        this.isCompareFinance = isCompareFinance;
        /**
         * is flag for widget in widget integration
         * @type {Boolean}
         * @private
         */
        this._isWidgetInWidget = isWidgetInWidget;
        /**
         * theme per model
         * @type {string}
         * @private
         */
        this._theme = theme;
        /**
         * theme per model
         * @type {boolean}
         * @private
         */
        this._isLocaleAphelia = isLocaleAphelia;
        /**
         * origin for tagging
         * @type {string}
         * @private
         */
        this._origin = origin;
        /**
         * @desc stores flow ID
         * Flow id does not exist on local serve instance of the application
         * @type {String}
         * @private
         */
        this._flowId = '';
        /**
         * @desc stores flowProps of entities
         * @type {Object}
         * @private
         */
        this._flowProps = flowProps || {};
        /**
         * @desc stores reference to callback function in controller
         * @type {Function}
         * @private
         */
        this._setFlowConfigurationCallback = setFlowConfigurationCallback;
        /**
         * @desc stores environment
         * @type {String}
         * @private
         */
        this._environment = environment;
        /**
         * @desc stores event manager instance
         * @type {EventManager}
         * @private
         */
        this._eventManager = new EventManager();
        /**
         * @desc stores resolutions instance
         * @type {Resolutions}
         * @private
         */
        this._resolutions = new Resolutions(this._eventManager, resolutionsConfig);
        /**
         * @desc contains all components, when components should be loaded asyc should have value null
         * @type {Object}
         * @private
         */
        this._components = components;
        /**
         * @desc entityBuilder instance
         * @type {EntityBuilder}
         * @public
         */
        this.entityBuilder = null;
        /**
         * @desc entityBuilder type, posible types: 'simulator', 'onlineApproval'
         * @type {string|null}
         * @public
         */
        this.elementType = null;
        /**
         * @desc stores BSSBackendConnector Object
         * @type {Object}
         * @private
         */
        this._BSSBackendConnector = new BSSBackendConnector(this._devMode);
        /**
         * @desc stores initial entity Id
         * @type {String}
         * @private
         */
        this._initialEntityId = null;
        /**
         * @desc stores current entity Id
         * @type {String}
         * @private
         */
        this._currentEntityId = null;
        /**
         * @desc stores current entity Id
         * @type {String}
         * @private
         */
        this._prevEntityId = null;
        /**
         * @desc stores id of the entity that should be shown after creation
         * @type {String}
         * @private
         */
        this._entityToBeShown = null;
        /**
         * @desc entity id selector; needed in case of error before entity init
         * @type {String}
         * @private
         */
        this._entitySelector = '#entity'; // set default entity container to #entity
        /**
         * @desc stores entity container object; needed in case of error before entity init
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._entityContainer = toolbox.$(this._entitySelector);
        /**
         * @desc stores flow configuration (all necessary url and dependencies)
         * @type {Object}
         * @private
         */
        this._flowConfiguration = null;
        /**
         * @desc all created entities, key is entityId
         * @type {Object}
         * @private
         */
        this._flowEntities = {};
        /**
         * @desc stores entities params given by the user
         * @type {Object}
         * @private
         */
        this._flowParams = {};
        /**
         * @desc stores formatter instance
         * @type {Formatter}
         * @private
         */
        this._formatter = null;
        /**
         * @desc id of the last update
         * @type {String}
         * @private
         */
        this._lastUpdateTimestamp = null;
        /**
         * @desc set current protocol
         * @type {string}
         * @private
         */
        this._protocol = 'https://';
        /**
         * @desc set current environment url
         * @type {string}
         * @private
         */
        this._environmentUrl = process.env.ENV_URL + '';
        /**
         * @desc counts loaded entities
         * @type {number}
         * @private
         */
        this._entityCounter = 0;
        /**
         * @desc error template loaded indicator
         * @type {boolean}
         * @private
         */
        this._simulatorErrorTemplateLoaded = false;
        /**
         * @desc flag which means which button was clicked, if true - confirm button else X button
         * @type {boolean}
         * @private
         */
        this._isCloseButton = false;
        /**
         * @desc flag which means dealer POS interface request loop has been canceled by for ex. destroying entity
         * @type {boolean}
         * @private
         */
        this._dealerPosInterfaceRequestCanceled = false;
        this._stopRequestsAfterNavTabClick = false;
        /**
         * @desc model id for BC
         * @type {String}
         * @private
         */
        this._modelId = null;
        /**
         * @desc car id for BC
         * @type {String}
         * @private
         */
        this._carId = null;
        /**
         * @desc url for request to BE
         * @type {String}
         * @private
         */
        this._url = null;
        /**
         * @desc finnancial details for Car
         * @type {String}
         * @private
         */
        this._detailsForCar = false;
        /**
         * @desc flag for popup PC for DE
         * @type {Boolean}
         * @private
         */
        this._isPopupPC = false;
        /**
         * @desc flag for tagging end
         * @type {Boolean}
         * @private
         */
        this._isTaggingFinished = false;
        /**
         * @desc object sent in postal
         * @type {Object}
         * @private
         */
        this._financeObject = null;
        /**
         * @desc quoteId for widget in widget integration callback function
         * @type {Function}
         * @private
         */
        this._setInsideWidgetQuoteIdCallback = setInsideWidgetQuoteIdCallback;
        /**
         * @desc quoteId for widget in widget integration value
         * @type {String}
         * @private
         */
        this._insideWidgetQuoteId = insideWidgetQuoteId;
        /**
         * @desc standalone for compare finance
         * @type {Boolean}
         * @private
         */
        this._standalone = standalone;
        /**
         * @desc compare finance texts data
         * @type {Array}
         * @private
         */
        this._compareFinanceTexts = null;
        /**
         * If popup with error should be shown on error respond from BE,
         * hidden on plan validation (IT monthly rates functionality)
         * @type {boolean}
         * @private
         */
        this._noErrorPopup = false;
        this.descriptionConfig = descriptionConfig;
        this.initConfiguration = initConfiguration;
    }
    Object.defineProperty(BaseControllerToolbox.prototype, "location", {
        /**
         * Set injection location of the element into store for access by submodules.
         * @param {'body' | 'popup' |  ''} _location the location where content of the element should be injected
         */
        set: function (_location) {
            toolbox.location = _location;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Check if flowId is valid
     * @param {string} flowId
     * @private
     */
    BaseControllerToolbox.prototype._validateFlowId = function (flowId) {
        if (!flowId) {
            var errObj = {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox critical error: parameter flowId is required',
            };
            this._errorHandler(null, errObj);
            return false;
        }
        return true;
    };
    /**
     * Check if flowParams are not empty
     * @param {Object} args
     * @private
     */
    BaseControllerToolbox.prototype._validateFlowProps = function (_a, standalone) {
        var brand = _a.brand, lang = _a.lang, country = _a.country;
        if (standalone)
            return;
        if (!brand || !lang || !country) {
            this._errorHandler(null, {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox constructor error: parameters brand, lang and country are necessary',
            });
        }
    };
    /**
     * NBSS-9498
     * Add additional class with min-height style
     * that we set on simulator initialization to prevent cutting of simulator content by client style
     * @private
     */
    BaseControllerToolbox.prototype._addModalPopupStyle = function () {
        logger.info('ControllerToolbox => function: _addModalPopupStyle');
        if (this._resolutions &&
            ['xs', 'sm'].indexOf(this._resolutions._localCurrentDevice !== -1)) {
            this._entityContainer
                .parent('.tor-modal-body')
                .addClass('bss-modal-popup');
        }
    };
    /**
     * NBSS-9498
     * Clear additional class with min-height style
     * that we set on simulator initialization to prevent cutting of simulator content by client style
     * @private
     */
    BaseControllerToolbox.prototype._clearModalPopupStyle = function () {
        logger.info('ControllerToolbox => function: _clearModalPopupStyle');
        this._entityContainer
            .parent('.tor-modal-body')
            .removeClass('bss-modal-popup');
        this._entityContainer.removeClass('bss-scroll');
    };
    /**
     * @desc update finance data object with additional event data (taken e.g. from ui description eventData attribute)
     * @param {Object} closeEventObject close event object
     * @param {Object} eventData event data object (taken e.g. from ui description eventData attribute)
     * @public
     */
    BaseControllerToolbox.prototype._getUpdatedFinanceObjectWithEventData = function (closeEventObject, eventData) {
        if (!toolbox._.isEmpty(eventData)) {
            closeEventObject.financeObject = toolbox._.assign(closeEventObject.financeObject, eventData);
        }
        return closeEventObject;
    };
    /**
     * @desc update finance data object for closing sim
     * @param {Object} data finance object
     * @public
     */
    BaseControllerToolbox.prototype._getUpdatedFinanceObjectForClose = function (data) {
        var channel = 'com.toyota.tme.quoteService';
        var topic = 'quote.set';
        data.financeObject.data.finance = this._finance;
        if (data.financeObject.channel !== channel)
            data.financeObject.channel = channel;
        if (data.financeObject.topic !== topic)
            data.financeObject.topic = topic;
        return data;
    };
    /**
     * @desc close update finance method
     * @public
     */
    BaseControllerToolbox.prototype._closeUpdateFinance = function (publisherName, eventData) {
        var _a, _b;
        logger.info('ControllerToolbox => function: _closeUpdateFinance | Params: ', publisherName, eventData);
        this._financeObject = {
            channel: 'com.toyota.tme.quoteService',
            topic: 'quote.set',
            data: { finance: this._finance },
        };
        var data = this._getUpdatedFinanceObjectWithEventData({
            finance: this._finance,
            financeObject: this._financeObject,
        }, eventData);
        data = this._getUpdatedFinanceObjectForClose(data);
        this._eventManager.publish('bss-close-entity-' + this._flowId, BASE_PUBLISHER_NAME, data, true);
        if (this.entityBuilder._entityMap.size > 0) {
            this._publishTaggingEvent(this._currentEntity._entityId, 'simulatorConfirmClosing_' +
                this.entityBuilder._entityMap.entries().next().value[1]
                    ._entityActiveProductId);
            this._isCloseButton = true;
            (_b = (_a = toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._currentEntity._entityId]) === null || _b === void 0 ? void 0 : _b.publish('saveEntity', toolbox.resultDataFlat[toolbox.currentProductId]);
        }
        this._eventManager.publish('hide-build-amd-modal', BASE_PUBLISHER_NAME, {}, true);
    };
    /**
     * @desc method replace @protocol@ with current protocol
     * @param data
     * @return {Object}
     * @private
     */
    BaseControllerToolbox.prototype._setProtocol = function (data) {
        logger.info('ControllerToolbox => function: _setProtocol | Params: ', data);
        return JSON.parse(JSON.stringify(data)
            .replace(/@protocol@/g, this._protocol)
            .replace(/@environment@/g, this._environmentUrl));
    };
    /**
     * @desc gets the entity order
     * @param {String} entityId
     * @return {Number} entity order
     * @private
     */
    BaseControllerToolbox.prototype._getEntityOrder = function (entityId) {
        logger.info('ControllerToolbox => function: _getEntityOrder | Params: ', entityId);
        return this._flowEntities[entityId].order;
    };
    /**
     * @desc get inner overlay for current entity
     * @return {Object} inner overlay object
     * @public
     */
    BaseControllerToolbox.prototype.getInnerEntityOverlay = function () {
        logger.info('ControllerToolbox => function: getInnerEntityOverlay | Params: ', {});
        var entity = this.entityBuilder.entities.get(this._currentEntityId);
        var innerOverlayContainer;
        if (entity.$overlayElement.length)
            innerOverlayContainer = entity.$overlayElement[0];
        return { innerOverlayContainer: innerOverlayContainer };
    };
    /**
     * @desc gets the default offer for given entity
     * @param {String} [entityId=null]
     * @return {Object} default offer
     * @public
     */
    BaseControllerToolbox.prototype.getDefaultOffer = function (entityId) {
        if (entityId === void 0) { entityId = null; }
        logger.info('ControllerToolbox => function: getDefaultOffer | Params: ', entityId);
        var entityIdx = entityId === null ? this._currentEntityId : entityId;
        return this._flowEntities[entityIdx].defaultOffer;
    };
    /**
     * @desc set the default offer for given entity and entity params
     * @param {String} [entityId=null]
     * @param {Object} defaultOffer offer
     * @private
     */
    BaseControllerToolbox.prototype._setDefaultOffer = function (entityId, defaultOffer) {
        logger.info('ControllerToolbox => function: _setDefaultOffer | Params: ', entityId, defaultOffer);
        if (toolbox.$.isEmptyObject(this.getDefaultOffer(entityId))) {
            this._setIsDefaultOfferOutOfDate(false, entityId);
        }
        if (typeof defaultOffer.resultData !== 'undefined') {
            this._flowEntities[entityId].defaultOffer = defaultOffer.resultData;
        }
        else {
            this._flowEntities[entityId].defaultOffer = defaultOffer;
        }
    };
    /**
     * @desc get isDefaultOfferOutOfDate value for given entity
     * @param {String} [entityId=null]
     * @return {Boolean} isDefaultOfferOutOfDate
     * @private
     */
    BaseControllerToolbox.prototype._getIsDefaultOfferOutOfDate = function (entityId) {
        if (entityId === void 0) { entityId = null; }
        logger.info('ControllerToolbox => function: _getIsDefaultOfferOutOfDate | Params: ', entityId);
        var entityIdx = entityId === null ? this._currentEntityId : entityId;
        return this._flowEntities[entityIdx].isDefaultOfferOutOfDate;
    };
    /**
     * @desc set isDefaultOfferOutOfDate value for given entity
     * @param {Boolean} isOutOfDate
     * @param {String} [entityId=null]
     * @private
     */
    BaseControllerToolbox.prototype._setIsDefaultOfferOutOfDate = function (isOutOfDate, entityId) {
        if (entityId === void 0) { entityId = null; }
        logger.info('ControllerToolbox => function: _setIsDefaultOfferOutOfDate | Params: ', isOutOfDate, entityId);
        var entityIdx = entityId === null ? this._currentEntityId : entityId;
        this._flowEntities[entityIdx].isDefaultOfferOutOfDate = isOutOfDate;
    };
    /**
     * @desc set the toolbox.resultDataFlat object properties & values
     * @param {Object} offer - custom offer object
     * @private
     */
    BaseControllerToolbox.prototype._setResultDataFlat = function (offer) {
        logger.info('ControllerToolbox => function: _setResultDataFlat | Params: ', offer);
        for (var prod in offer) {
            if (typeof offer[prod] === 'object') {
                var product = prod in toolbox.resultDataFlat ? toolbox.resultDataFlat[prod] : {};
                var keys = Object.keys(offer[prod]);
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key = keys_1[_i];
                    var keyValue = offer[prod][key];
                    if (keyValue === null || typeof keyValue != 'object') {
                        this.flatenPrimitiveDataValue(keyValue, product, key);
                    }
                    else if (key === 'components') {
                        console.log('key === components');
                        this.flattenComponentArrayDataValues(keyValue, key, product);
                    }
                }
                toolbox.resultDataFlat[prod] = product;
            }
        }
    };
    BaseControllerToolbox.prototype.flattenComponentArrayDataValues = function (componentTypes, key, product) {
        var componentTypesKeys = Object.keys(componentTypes);
        for (var _i = 0, componentTypesKeys_1 = componentTypesKeys; _i < componentTypesKeys_1.length; _i++) {
            var componentTypeKey = componentTypesKeys_1[_i];
            this.flattenDataArrayValues(componentTypes, componentTypeKey, key, product);
        }
    };
    BaseControllerToolbox.prototype.flattenDataArrayValues = function (componentTypes, componentTypeKey, key, product) {
        if (Symbol.iterator in Object(componentTypes[componentTypeKey])) {
            for (var _i = 0, _a = componentTypes[componentTypeKey]; _i < _a.length; _i++) {
                var componentTypeValue = _a[_i];
                var componentTypeValuePrefix = "".concat(key, "_").concat(componentTypeKey, "_").concat(componentTypeValue.name);
                this.flattenArrayDataValue(componentTypeValue, componentTypeValuePrefix, product);
            }
        }
    };
    BaseControllerToolbox.prototype.flattenArrayDataValue = function (componentTypeValue, componentTypeValuePrefix, product) {
        if ('value' in componentTypeValue) {
            var valueString = "".concat(componentTypeValuePrefix, "_value");
            product[valueString] = componentTypeValue.value;
        }
        if ('disabled' in componentTypeValue) {
            var disabledString = "".concat(componentTypeValuePrefix, "_disabled");
            product[disabledString] = componentTypeValue.disabled;
        }
        if ('checked' in componentTypeValue) {
            var checkedString = "".concat(componentTypeValuePrefix, "_checked");
            product[checkedString] = componentTypeValue.checked;
        }
        if ('variable' in componentTypeValue) {
            var variableString = "".concat(componentTypeValuePrefix, "_variable");
            product[variableString] = componentTypeValue.variable;
        }
    };
    BaseControllerToolbox.prototype.flatenPrimitiveDataValue = function (keyValue, product, key) {
        if (typeof keyValue === 'string') {
            product[key] = keyValue.replace('@protocol@', location.protocol + '//');
        }
        else {
            product[key] = keyValue;
        }
    };
    /**
     * @desc set the toolbox.layoutTexts as a copy of texts
     * @param {Object} config - object with layout & resultData
     * @private
     */
    BaseControllerToolbox.prototype._cacheLayoutTexts = function (config) {
        logger.info('ControllerToolbox => function: _cacheLayoutTexts | Params: ', config);
        if (config.layout && typeof config.layout.texts === 'object') {
            toolbox.layoutTexts = JSON.parse(JSON.stringify(config.layout.texts));
        }
    };
    /**
     * @desc set the default offer for given entity and entity params and save previous offer
     * @param {String} entityId - id of entity for which default offer is received
     * @param {Object} offer - custom offer object
     * @private
     */
    BaseControllerToolbox.prototype._setCustomOffer = function (entityId, offer) {
        logger.info('ControllerToolbox => function: _setCustomOffer | Params: ', entityId, offer);
        this._saveCustomOfferPrevious(entityId);
        var tempOffer = offer;
        // if is on init loop through offer.resultData
        if (toolbox._.has(offer, 'resultData')) {
            tempOffer = offer.resultData;
        }
        this._setResultDataFlat(tempOffer);
        // set integrationMode in resultDataFlat for BC's
        if (this._options && this._options.integrationMode) {
            toolbox.resultDataFlat[this._flowEntities[this._currentEntityId].currentProdId].integrationMode = this._options.integrationMode;
        }
        var customOffer = this.getCustomOffer(entityId);
        if (!toolbox._.has(customOffer, 'resultData')) {
            customOffer.resultData = {};
        }
        toolbox._.forEach(tempOffer, function (prod, prodId) {
            customOffer.resultData[prodId] = prod;
        });
    };
    /**
     * @desc get the default offer local object for current or given entity
     * @param {String} [entityId=null]
     * @return  {Object} entity customOffer
     * @public
     */
    BaseControllerToolbox.prototype.getCustomOffer = function (entityId) {
        if (entityId === void 0) { entityId = null; }
        logger.info('ControllerToolbox => function: getCustomOffer | Params: ', entityId);
        var entityIdx = entityId === null ? this._currentEntityId : entityId;
        return this._flowEntities[entityIdx].customOffer;
    };
    /**
     * @desc save previous offer settings for entity
     * @param {String} entityId
     * @private
     */
    BaseControllerToolbox.prototype._saveCustomOfferPrevious = function (entityId) {
        logger.info('ControllerToolbox => function: _saveCustomOfferPrevious | Params: ', entityId);
        this._flowEntities[entityId].customOfferPrevious = JSON.parse(JSON.stringify(this.getCustomOffer(entityId)));
    };
    /**
     * @desc check if entity with given ID is already created
     * @param {String} entityId
     * @return {Boolean} returns true when entity is created
     * @private
     */
    BaseControllerToolbox.prototype._checkEntityExistence = function (entityId) {
        logger.info('ControllerToolbox => function: _checkEntityExistence | Params: ', entityId);
        return (this.entityBuilder &&
            typeof this.entityBuilder.entities.get(entityId) !== 'undefined');
    };
    /**
     * @desc create all entities needed for creating entity with given in
     * @param {String} entityId
     * @private
     */
    BaseControllerToolbox.prototype._createFlowEntity = function (entityId) {
        logger.info('ControllerToolbox => function: _createFlowEntity | Params: ', entityId);
        // set this entity as _currentEntity
        this._setActiveEntity(entityId);
        // check dependencies
        var entityDepList = this._getEntityDependenciesArr(entityId);
        // create dependent entity (if is not already created); and then create and show entity with given id
        if (entityDepList.length) {
            var depEntityId = entityDepList[0];
            if (!this._checkEntityExistence(depEntityId)) {
                this._createEntity(depEntityId);
                this._eventManager.subscribe('bss-flow-' + this._flowId + '-entity-' + depEntityId + '-created', this._createEntity.bind(this, entityId), 'ControllerToolbox');
                return;
            }
        }
        // create entity with given id and show it
        this._createEntity(entityId);
    };
    /**
     * Return element type shortcut
     * @param {string} entityId
     * @returns {string}
     * @private
     */
    BaseControllerToolbox.prototype._getElementType = function (entityId) {
        logger.info('ControllerToolbox => function: _getElementType | Params: ', entityId);
        switch (this._flowEntities[entityId].type) {
            case 'stockCarsSimulator':
                return 'sc';
            case 'onlineApproval':
                return 'oa';
            case 'budgetCalculator':
                return 'bc';
            case 'productComparison':
                return 'pc';
            default:
                return 'nc';
        }
    };
    /**
     * @desc set entity with given id as current entity
     * @param {String} entityId
     * @private
     */
    BaseControllerToolbox.prototype._setActiveEntity = function (entityId) {
        var _a;
        logger.info('ControllerToolbox => function: _setActiveEntity | Params: ', entityId);
        if (entityId !== null && typeof entityId !== 'undefined') {
            if (this._currentEntityId !== entityId) {
                if (this._prevEntityId !== this._currentEntityId) {
                    this._prevEntityId = this._currentEntityId;
                }
                this._currentEntityId = entityId;
            }
            if (this.entityBuilder) {
                this._currentEntity = this.entityBuilder.entities.get(entityId);
            }
            toolbox.currentEntity =
                this._flowConfiguration.entities[this._currentEntityId];
            toolbox.currentEntity.entityId = this._currentEntityId;
            var activeEntityTagging = (_a = toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._prevEntityId];
            if (activeEntityTagging)
                activeEntityTagging.onHold = true;
        }
    };
    /**
     * @desc check if entityId is given by the user
     * @param {String} entityId - entity id to check
     * @private
     */
    BaseControllerToolbox.prototype._checkEntityId = function (entityId) {
        logger.info('ControllerToolbox => function: checkEntityId | Params: ', entityId);
        if (entityId === null) {
            var errObj = {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox checkEntityId error: entityId is necessary.',
            };
            this._errorHandler(null, errObj);
        }
    };
    /**
     * @desc check if flowConfiguration is present locally
     * @public
     */
    BaseControllerToolbox.prototype.checkFlowConfiguration = function () {
        logger.info('ControllerToolbox => function: checkFlowConfiguration');
        if (this._flowConfiguration === null) {
            var errObj = {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox checkFlowConfiguration error: flowConfiguration is undefined, use "xxxEventName" event listener to prevent this error.',
            };
            this._errorHandler(null, errObj);
        }
    };
    /**
     * @desc set entity configuration
     * @param {String} entityId - entity id
     * @param {Object} data - flow configuration object
     * @private
     */
    BaseControllerToolbox.prototype._setEntityConfiguration = function (entityId, data) {
        logger.info('ControllerToolbox => function: _setEntityConfiguration | Params: ', entityId, data);
        try {
            var config = data;
            if (config.layout && config.layout.formatters) {
                this._formatter = new Formatter(config.layout.formatters);
            }
            else {
                var currentFormatter = {};
                this._formatter = new Formatter(currentFormatter);
            }
            this._flowEntities[entityId].configuration = config;
            this._cacheLayoutTexts(config);
        }
        catch (e) {
            var errObj = {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox _setEntityConfiguration error - ' + e,
            };
            this._errorHandler(null, errObj);
        }
    };
    BaseControllerToolbox.prototype._onParamsChange = function (publishername, params) {
        var _this = this;
        logger.info('ControllerToolbox => function: _onParamsChange | Params: ', publishername, params);
        var currentTriggerName = null;
        toolbox._.forIn(params[this._currentEntity._entityActiveProductId], function (value, key) {
            if (key !== 'triggerName') {
                _this._currentValueChange = key;
            }
            else {
                currentTriggerName = value;
            }
            if (_this._tempOAOffer) {
                var self_1 = _this;
                for (var item in _this._tempOAOffer[_this._currentEntity._entityActiveProductId]) {
                    if (item === key) {
                        self_1._tempOAOffer[self_1._currentEntity._entityActiveProductId][key] = value;
                        return;
                    }
                }
            }
        });
        if (currentTriggerName) {
            toolbox.resultDataFlat[this._currentEntity._entityActiveProductId].triggerName = currentTriggerName;
        }
    };
    /**
     * Update nested components values to string and updated values with new dependencies, after return to entity.
     * @param data - data from component updated after user change
     * @param depValues - data from dependencies
     * @private
     */
    BaseControllerToolbox.prototype._updateComponentsVals = function (data, depValues) {
        logger.info('ControllerToolbox => function: _updateComponentsVals | Params: ', data, depValues);
        // code too brittle to refactor without unit tests
        // eslint-disable-next-line sonarjs/cognitive-complexity
        toolbox.$.each(data, function (key, value) {
            if (typeof data[key] !== 'object' && value && key !== 'step') {
                data[key] = value.toString();
            }
            else if (key === 'step') {
                data[key] = value;
            }
            else if (data[key] !== null && data[key] !== '') {
                // set errors values
                if (key === 'errors') {
                    toolbox.$.each(data[key], function (errorKey, errorValue) {
                        data[key][errorKey] = errorValue.toString();
                    });
                }
                else {
                    toolbox.$.each(data[key], function (key2) {
                        if (typeof data[key][key2] === 'object') {
                            var _loop_1 = function (i) {
                                var tempItem = data[key][key2][i];
                                toolbox.$.each(tempItem, function (key3, value) {
                                    if (key3 === 'values') {
                                        var _loop_2 = function (j) {
                                            var tempItem_1 = data[key][key2][i][key3][j];
                                            toolbox.$.each(tempItem_1, function (key, value) {
                                                if (typeof value !== 'object') {
                                                    tempItem_1[key] =
                                                        value === null ? null : value.toString();
                                                }
                                            });
                                        };
                                        for (var j = 0; j < data[key][key2][i][key3].length; j++) {
                                            _loop_2(j);
                                        }
                                    }
                                    if (key2 === 'dropdownComponents' && key3 === 'rule') {
                                        var tempItem_2 = data[key][key2][i][key3];
                                        toolbox.$.each(tempItem_2, function (key4) {
                                            if (typeof tempItem_2[key4] === 'undefined') {
                                                tempItem_2[key4] = [];
                                            }
                                            toolbox.$.each(tempItem_2[key4], function (j) {
                                                toolbox.$.each(tempItem_2[key4][j], function (key5, value) {
                                                    var tempItem = data[key][key2][i][key3][key4][j];
                                                    tempItem[key5] =
                                                        value === null ? null : value.toString();
                                                });
                                            });
                                        });
                                    }
                                    if (key3 !== 'name' && key3 !== 'values' && key3 !== 'rule') {
                                        //find value: item = productId, key =  'components', key2 = 'textInputComponents', i = 'name', key3 = 'value'
                                        tempItem[key3] =
                                            tempItem[key3] === null ? null : value.toString();
                                    }
                                });
                                if (toolbox._.has(depValues, tempItem['name']) &&
                                    toolbox._.has(tempItem, 'value')) {
                                    tempItem.value =
                                        depValues[tempItem['name']] === null
                                            ? null
                                            : depValues[tempItem['name']].toString();
                                }
                            };
                            for (var i = 0; i < data[key][key2].length; i++) {
                                _loop_1(i);
                            }
                        }
                        else {
                            data[key][key2] = data[key][key2].toString();
                        }
                    });
                }
            }
        });
    };
    /**
     * @desc set current product id
     * @param {String} publisherName - publisher name
     * @param {Object} params - params send by publisher
     * @private
     */
    BaseControllerToolbox.prototype._onProductChange = function (publisherName, params) {
        logger.info('ControllerToolbox => function: _onProductChange | Params: ', publisherName, params);
        var productId = this._prevEntityId || this._currentEntityId;
        this._flowEntities[productId].currentProdId = params.prodID;
        if (this.elementType === 'usedCarsSimulator' &&
            this._flowParams.country === 'pl') {
            var offer = this._currentData.resultData[this._flowEntities[this._currentEntityId].currentProdId];
            this._setFinanceObject(offer);
            this._onFinanceChange(offer);
        }
    };
    /**
     * Return product id of currently chosen product
     * @returns {string}
     * @private
     */
    BaseControllerToolbox.prototype._getCurrentProdId = function () {
        logger.info('ControllerToolbox => function: _getCurrentProdId');
        return this.entityBuilder && this._prevEntityId
            ? this.entityBuilder.entities.get(this._prevEntityId)
                .entityActiveProductId
            : '';
    };
    /**
     * Callback on BE response after financial data change
     * @param error {{}}
     * @param res {{}}
     * @param checkInnerNodes {boolean}
     * @param offerId {string}
     * @param tempCustomOffer {{}}
     * @param url {string}
     * @param def {Promise}
     */
    // code too brittle to refactor without unit tests
    // eslint-disable-next-line sonarjs/cognitive-complexity
    BaseControllerToolbox.prototype._calculateOfferCallback = function (checkInnerNodes, offerId, tempCustomOffer, url, def, error, res) {
        logger.info('ControllerToolbox => function: calculateOfferCallback | Params: ', error, res);
        var data = this.parseRequest(res);
        // if there is no error and all data nodes exist
        if (this._configurationParams &&
            this._configurationParams.country === 'de' &&
            data &&
            data.layout &&
            data.layout.components) {
            var index = data.layout.components.findIndex(function (x) { return x.componentTemplate === 'fixedContainerTemplate'; });
            if (index !== -1) {
                data.layout.components[index].offHeightCalculation = false;
            }
        }
        if (this._checkRequestErrorAndData(error, data, 'getCalculatedOffer', checkInnerNodes, offerId)) {
            var requestParser = "".concat(process.env.ENV_NAME).toLowerCase() !== 'prod' &&
                localStorage.getItem('RequestParser');
            if (requestParser) {
                data = this._requestPreParser(url, data);
                logger.info('CHANGE DATA: ', data);
            }
            if (data && data[offerId] && data[offerId].quoteId) {
                var event_1 = new CustomEvent('BSSQuoteID', {
                    bubbles: true,
                    detail: { quoteId: data[offerId].quoteId },
                });
                document.dispatchEvent(event_1);
            }
            if (this._flowEntities[this._currentEntityId].type === 'budgetCalculator' &&
                data[offerId] &&
                data[offerId].details) {
                for (var param in data[offerId]) {
                    if (Object.hasOwn(tempCustomOffer, param)) {
                        delete tempCustomOffer[param];
                    }
                }
                Object.assign(data[offerId], tempCustomOffer);
            }
            if (typeof tempCustomOffer === 'object' &&
                tempCustomOffer.requestToDealerPosInterface + '' === 'true') {
                // after switch to talisman, the case for entityOaStatus will be removed
                var isTalismanApi = tempCustomOffer.apiSource === 'talisman';
                var urlDealerPosInterface = isTalismanApi
                    ? this._flowConfiguration.entities[this._currentEntityId].commonURLs
                        .entityOaTalismanStatus
                    : this._flowConfiguration.entities[this._currentEntityId].commonURLs
                        .entityOaStatus;
                var oaStatusInterval = data[offerId].oaStatusInterval
                    ? parseInt(data[offerId].oaStatusInterval, 10) * 1000
                    : 10 * 1000;
                var oaStatusTimeout = data[offerId].oaStatusTimeout
                    ? parseInt(data[offerId].oaStatusTimeout, 10) * 1000
                    : 10 * 60 * 1000;
                var oaStatusStartTime = new Date();
                var oaStatusEndTime = new Date(oaStatusStartTime.getTime() + oaStatusTimeout);
                if (!this._stopRequestsAfterNavTabClick) {
                    this._dealerPosInterfaceRequestCanceled = false;
                }
                if (!requestParser &&
                    urlDealerPosInterface &&
                    Object.hasOwn(data[offerId], 'internalProposalNumber') &&
                    data[offerId].submissionStatus === 'success' &&
                    !this._dealerPosInterfaceRequestCanceled) {
                    // after switch to talisman, 'else' for non-talisman replacement should be removed
                    if (isTalismanApi) {
                        urlDealerPosInterface = urlDealerPosInterface
                            .replace('{proposalNumber}', data[offerId].internalProposalNumber)
                            .replace('{businessId}', data[offerId].businessIdentifier);
                    }
                    else {
                        urlDealerPosInterface = urlDealerPosInterface
                            .replace('{internalProposalNumber}', data[offerId].internalProposalNumber)
                            .replace('{ngus}', data[offerId].ngus)
                            .replace('{country}', data[offerId].country);
                    }
                    this._sendRequestToDealerPosInterface(urlDealerPosInterface, data, oaStatusInterval, oaStatusEndTime, offerId).then(function () {
                        def.resolve(data);
                    });
                }
                else if (requestParser) {
                    def.resolve(data);
                }
                else {
                    var errObj = {
                        entityInstanceId: this.getCurrentEntityInstanceId(),
                        errorCode: 'DEFAULT_ERROR',
                    };
                    this._errorHandler(null, errObj);
                }
                this._eventManager.unsubscribeByOwner('ControllerToolboxTabClick');
                this._eventManager.subscribe('bss-step-navigation-tab-click-while-submit', this._onTabChangeWhileSentRequest.bind(this), 'ControllerToolboxTabClick');
            }
            else {
                def.resolve(data);
            }
        }
    };
    BaseControllerToolbox.prototype.parseRequest = function (data) {
        var _a;
        var elementType = this._getElementTypePerRequest();
        var brand = this._flowParams.brand;
        var country = this._flowParams.country;
        var currentProductId = this._standalone
            ? null
            : this._flowEntities[this._currentEntityId].currentProdId;
        var quoteId = data ? (_a = data[currentProductId]) === null || _a === void 0 ? void 0 : _a.quoteId : null;
        if (this.isCompareFinance && data !== undefined) {
            data.cfTexts = this._compareFinanceTexts;
        }
        if (this._standalone && this._compareFinanceTexts) {
            data = {
                cfTexts: this._compareFinanceTexts,
                layout: {
                    components: null,
                    // texts: {
                    //   189059: {
                    //     product_link_label: 'What is PCP?',
                    //     product_link_url:
                    //       'https://www.toyota.co.uk/finance-insurance/personal-contract-purchase#/youtube/HeFoC9eTUQc',
                    //     product_name: 'Personal Contract Purchase',
                    //     product_name_hint:
                    //       'Personal Contract Purchase (PCP), is a flexible and popular plan that provides you with the option to change your car on a regular basis. Pay a Deposit → Regular monthly payments → Choose to retain, return or even renew your Toyota',
                    //   },
                    // },
                },
                resultData: {
                    189059: {
                        productId: '189059',
                        productName: 'PCP Toyota',
                        productType: 'gb_pcp_toyota',
                    },
                    189060: {
                        productId: '189060',
                        productName: 'PCH Toyota',
                        productType: 'gb_pch_toyota',
                    },
                    189061: {
                        productId: '189061',
                        productName: 'HP Toyota',
                        productType: 'gb_hp_toyota',
                    },
                },
            };
        }
        if (this._setInsideWidgetQuoteIdCallback)
            this._setInsideWidgetQuoteIdCallback(quoteId);
        return parseRequest({
            res: data,
            elementType: elementType,
            brand: brand,
            country: country,
            descriptionConfig: this.descriptionConfig,
            flowId: this._flowId,
            entityId: this.getCurrentEntityId(),
            insuranceQuoteId: this._insideWidgetQuoteId,
            flowParams: this._flowParams,
            location: toolbox.location,
            isLocationBody: toolbox.location === 'body',
            productType: this.productType,
            isCompareFinance: this.isCompareFinance,
            origin: this._origin,
            privateUrl: this._privateUrl,
            initConfiguration: this.initConfiguration,
            standalone: this._standalone,
        });
    };
    /**
     * @desc get elementType for request
     * @returns {string}
     * @private
     */
    BaseControllerToolbox.prototype._getElementTypePerRequest = function () {
        if (this.elementType === 'compareFinance')
            return this.elementType;
        return this._flowEntities[this._currentEntityId].type;
    };
    /**
     * _requestPreParser - modify respond before inject into app.
     * @param url
     * @param data
     * @returns {*}
     */
    BaseControllerToolbox.prototype._requestPreParser = function (url, data) {
        var mergeObject = null;
        try {
            mergeObject = JSON.parse(localStorage.getItem('RequestParser'));
            if (mergeObject.url && mergeObject.data && url.match(mergeObject.url)) {
                if (data.layout && data.activeTabId) {
                    data.layout.components[1].activeTabId = data.activeTabId;
                }
                return toolbox.$.extend(true, {}, data, mergeObject.data);
            }
            else {
                return data;
            }
        }
        catch (e) {
            logger.error('ControllerToolbox => function: _requestPreParser error when try bind values');
        }
    };
    /**
     * @desc return dependencies values for given entity
     * @param {String} entityId
     * @return {Object} props and values from entity dependencies
     * @private
     */
    BaseControllerToolbox.prototype._getEntityDependenciesValues = function (entityId) {
        logger.info('ControllerToolbox => function: _getEntityDependenciesValues | Params: ', entityId);
        if (Object.hasOwn(this._flowEntities[entityId], 'initData') &&
            this._flowEntities[entityId].initData) {
            // When element contains initData not use dependencies.
            return toolbox.$.extend({}, this._flowEntities[entityId].initData);
        }
        var dep = this._flowEntities[entityId].dependencies;
        var depValues = {};
        if (dep !== null && typeof dep !== 'undefined') {
            var depEntityId = this._getEntityDependenciesArr(entityId)[0];
            var depEntityProdId = this.entityBuilder.entities.get(depEntityId).entityActiveProductId;
            var depFields = void 0;
            var depEntityDataResult = void 0;
            if (depEntityProdId !== null) {
                depFields = dep[depEntityId][depEntityProdId];
                depEntityDataResult =
                    this._flowEntities[depEntityId].configuration.resultData[depEntityProdId];
                var initialDepEntityTexts = this._flowEntities[this._initialEntityId].configuration.layout.texts[depEntityProdId];
                this.getDependenciesValuesForGivenEntityAndProductId(depFields, depEntityDataResult, initialDepEntityTexts, depValues);
            }
        }
        // example: {"price": "8420000", "totalDuration": "60", "monthlyPayment": "137363.27672855011800951224729005"}
        return depValues;
    };
    BaseControllerToolbox.prototype.getDependenciesValuesForGivenEntityAndProductId = function (depFields, depEntityDataResult, initialDepEntityTexts, depValues) {
        // get dependencies values for given entity and product id
        for (var i = 0, len = depFields.length; i < len; i++) {
            var prop = depFields[i];
            var val = depEntityDataResult[prop];
            // if there isn't prop value get it from simulator texts
            if (!val) {
                val = initialDepEntityTexts[prop];
            }
            depValues[prop] = typeof val === 'undefined' ? null : val;
        }
    };
    /**
     * @desc return update dependencies values for given entity with new request
     * @param {Object} depValues
     * @param {Object} data
     * @return {Object} props and values from entity dependencies
     * @private
     */
    BaseControllerToolbox.prototype._updateEntityDependenciesValues = function (depValues, data) {
        logger.info('ControllerToolbox => function: _updateEntityDependenciesValues | Params: ', depValues, data);
        var currentData = data;
        if (typeof currentData !== 'undefined' &&
            typeof depValues !== 'undefined') {
            depValues = toolbox.$.extend(depValues, currentData);
            if (toolbox._.has(depValues, 'components')) {
                delete depValues.components;
            }
        }
        // example: {"price": "8420000", "totalDuration": "60", "monthlyPayment": "137363.27672855011800951224729005"}
        return depValues;
    };
    /**
     * @desc returns array of entities from which entity is dependent
     * @param {String} entityId
     * @return {Array} array of dependent entities ids
     * @private
     */
    BaseControllerToolbox.prototype._getEntityDependenciesArr = function (entityId) {
        logger.info('ControllerToolbox => function: _getEntityDependenciesArr | Params: ', entityId);
        var dep = [];
        toolbox._.forEach(this._flowEntities[entityId].dependencies, function (prodIds, depEntityId) {
            dep.push(depEntityId);
        });
        return dep;
    };
    /**
     * Check if entity has 'simulator' type
     * @param {string} entityId
     * @returns {boolean}
     * @private
     */
    BaseControllerToolbox.prototype._isSimulator = function (entityId) {
        return (this._flowEntities[entityId].type === 'simulator' ||
            this._flowEntities[entityId].type === 'stockCarsSimulator');
    };
    /**
     * @desc show entity with given id
     * @param {String} currentEntityId
     * @private
     */
    BaseControllerToolbox.prototype._showEntity = function (currentEntityId) {
        logger.info('ControllerToolbox => function: _showEntity | Params: ', currentEntityId);
        var self = this;
        var entityContainer;
        var entityObj;
        var entityInstanceId;
        var event;
        toolbox._.forEach(this._flowEntities, function (entityData, entityId) {
            entityContainer = entityData.entityContainer;
            entityObj = self.entityBuilder.entities.get(entityId);
            // if this entity is not created yet - add proper class and return
            if (typeof entityObj === 'undefined') {
                entityContainer.addClass(HIDDEN_CLASS).hide();
                return;
            }
            entityInstanceId = entityObj.entityInstanceId;
            if (entityId === currentEntityId) {
                // start resize and scroll events from new entity
                self._eventManager.publish('bss-start-resize-for-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                self._eventManager.publish('bss-start-scroll-for-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                // show new entity
                entityContainer.removeClass(HIDDEN_CLASS).show(0, function () {
                    self._eventManager.publish('bss-entity-is-shown-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                    if (toolbox.$('.bss-button--online-approval button')) {
                        toolbox
                            .$('.bss-button--online-approval button')
                            .prop('disabled', false);
                    }
                });
                event = new Event('resize');
                window.dispatchEvent(event);
            }
            else if (!entityContainer.hasClass(HIDDEN_CLASS)) {
                // close slide-up layer, stop resize and scroll events from old entities
                self._eventManager.publish('bss-hide-slide-up-layer-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                self._eventManager.publish('bss-stop-resize-for-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                self._eventManager.publish('bss-stop-scroll-for-' + entityInstanceId, BASE_PUBLISHER_NAME, {});
                // hide old entities
                entityContainer.addClass(HIDDEN_CLASS).hide();
            }
        });
        this._setActiveEntity(currentEntityId);
    };
    /**
     * @desc check if given configuration data node exists
     * @param {Object} node - data node
     * @param {String} nodeName - data node name
     * @return {Boolean} return true if node exist
     * @private
     */
    BaseControllerToolbox.prototype._hasConfigNode = function (node, nodeName) {
        logger.info('ControllerToolbox => function: _hasConfigNode | Params: ', node, nodeName);
        return !(node === null ||
            node === {} ||
            node === '' ||
            typeof node === 'undefined');
    };
    /**
     * @desc set flow params
     * @param {Object} params - flow params to set
     * @param {Boolean} overrideParamObj -  default false, when set to true 'params' parameter object override whole local params for given entity
     * @public
     */
    BaseControllerToolbox.prototype.setFlowParams = function (params, overrideParamObj) {
        logger.info('ControllerToolbox => function: setFlowParams | Params: ', params, overrideParamObj);
        if (params === null) {
            return;
        }
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            var errObj = {
                entityInstanceId: this.getCurrentEntityInstanceId(),
                errorMsg: 'ControllerToolbox setFlowParams error: Entity parameters must be given as object.',
            };
            this._errorHandler(null, errObj);
        }
        if (overrideParamObj === true) {
            this._flowParams = params;
        }
        else {
            for (var item in params) {
                this._flowParams[item] = params[item];
            }
        }
        // NBSS-9540 Update default language by language from parameters set on simulator initialization
        if (params.language) {
            this._flowProps.lang = params.language;
        }
        var self = this;
        toolbox._.forEach(this._flowEntities, function (entityData, entityId) {
            self._setIsDefaultOfferOutOfDate(true, entityId);
        });
    };
    /**
     * @desc retrieve value of parameter provided by integrator, user or calculated
     * @param {String} setType - type of offer
     * @param {String} paramName - name of parameter
     * @return value of parameter provided by integrator
     * @public
     */
    BaseControllerToolbox.prototype.getParam = function (setType, paramName) {
        logger.info('ControllerToolbox => function: getParam | Params: ', setType, paramName);
        var errObj = {
            entityInstanceId: this.getCurrentEntityInstanceId(),
            errorMsg: 'ControllerToolbox getParam error: ',
        };
        if (setType.toLowerCase() === 'default') {
            try {
                var defaultOffers = this.getDefaultOffer();
                if (typeof defaultOffers[paramName] !== 'undefined') {
                    return defaultOffers[paramName];
                }
                errObj.errorMsg += 'No data for given property: ' + paramName;
                this._errorHandler(null, errObj);
            }
            catch (err) {
                errObj.errorMsg += 'No default offer for currentEntity ' + err;
                this._errorHandler(null, errObj);
            }
        }
        else if (setType.toLowerCase() === 'custom') {
            try {
                var offerParam = this.getCustomOffer()[paramName];
                if (typeof offerParam !== 'undefined') {
                    return offerParam;
                }
                errObj.errorMsg += 'No data for given property: ' + paramName;
                this._errorHandler(null, errObj);
            }
            catch (err) {
                errObj.errorMsg += 'No custom offer for currentEntity ' + err;
                this._errorHandler(null, errObj);
            }
        }
        else {
            errObj.errorMsg += 'setType must be equal to "default" or "custom"';
            this._errorHandler(null, errObj);
        }
    };
    /**
     * @decs callback on {bss-update-finance-$ENTITY-INSTANCE-ID} event published by components
     * @param {String} publisherName
     * @param {Object} data
     * @private
     */
    BaseControllerToolbox.prototype._onUpdateFinanceEvent = function (publisherName, data) {
        logger.info('ControllerToolbox => function: _onUpdateFinanceEvent | Params: ', publisherName, data);
        this._setFinanceObject(data);
    };
    /**
     * @desc method prepares quoteId and other params received from backend
     * @param {Object} offer
     * @private
     */
    BaseControllerToolbox.prototype._setFinanceObject = function (offer) {
        logger.info('ControllerToolbox => function: _financeQuoteId | Params: ', offer);
        if (toolbox._.has(offer, 'quoteId')) {
            this._finance = offer.quoteId;
        }
        // Add close event data for stock cars
        if (toolbox._.has(offer, 'data')) {
            this._financeObject = offer.data;
        }
    };
    /**
     * @desc error handling - function called after component error occurs
     * @param {String} publisherName
     * @param {Object} errorObject - error object with entityInstanceId and errorMsg
     * @private
     */
    BaseControllerToolbox.prototype._componentErrorHandler = function (publisherName, errorObject) {
        logger.info('ControllerToolbox => function: _componentErrorHandler | Params: ', publisherName, errorObject);
        if (errorObject.updateTimestamp !== this._lastUpdateTimestamp) {
            this._lastUpdateTimestamp = errorObject.updateTimestamp;
            this._errorHandler(publisherName, errorObject, true);
        }
    };
    /**
     * @desc gets the flow configuration and sets it localLy
     * @public
     */
    BaseControllerToolbox.prototype.getFlowConfiguration = function (parameters) {
        if (parameters === void 0) { parameters = null; }
        logger.info('ControllerToolbox => function: getFlowConfiguration', parameters);
        if (this._environment === null) {
            this._environment = 'PRODUCTION';
        }
        this._environment = this._environment.toUpperCase();
        var entityInstanceId = this.getCurrentEntityInstanceId();
        if (parameters === null) {
            parameters = {
                country: this._flowProps.country,
                environment: this._environment,
                brand: this._flowProps.brand,
                language: this._flowProps.lang,
            };
        }
        else if (Object.hasOwn(parameters, 'elementType') &&
            (parameters.elementType === 'productComparison' ||
                parameters.elementType === 'stockCarsSimulator')) {
            parameters = {
                elementType: parameters.elementType,
                country: this._flowProps.country,
                environment: this._environment,
                brand: this._flowProps.brand,
                language: this._flowProps.lang,
            };
        }
        else if (!Object.hasOwn(parameters, 'environment')) {
            parameters.environment = this._environment;
        }
        this._BSSBackendConnector.getConfiguration(this._flowConfigUrl, this.setFlowConfiguration.bind(this), JSON.stringify(parameters), entityInstanceId);
    };
    /**
     * @desc initial entity data returned from backend
     * @return {Object}
     * @public
     */
    BaseControllerToolbox.prototype.getInitialEntityData = function () {
        if (this._initialEntityId !== null) {
            return this._flowEntities[this._initialEntityId].initData;
        }
        return null;
    };
    /**
     * @desc simple getter for _currentEntityId
     * @return {String} current entity id
     * @public
     */
    BaseControllerToolbox.prototype.getCurrentEntityId = function () {
        return this._currentEntityId;
    };
    /**
     * @desc return current entity instance id
     * @return {Number} entityInstanceId
     * @public
     */
    BaseControllerToolbox.prototype.getCurrentEntityInstanceId = function () {
        logger.info('ControllerToolbox => function: getCurrentEntityInstanceId');
        if (this._currentEntity && this._currentEntity.entityInstanceId) {
            return this._currentEntity.entityInstanceId;
        }
    };
    /**
     * @desc set general entity container per flow (may be different per entity)
     * @param {String} selector - entity container selector
     */
    BaseControllerToolbox.prototype.setEntityContainer = function (selector) {
        logger.info('ControllerToolbox => function: setEntityContainer | Params: ', selector);
        this._entitySelector = selector;
        this._entityContainer = toolbox.$(this._entitySelector);
        if (this._currentEntityId !== null) {
            this._flowEntities[this._currentEntityId].entitySelector = selector;
            this._flowEntities[this._currentEntityId].entityContainer =
                toolbox.$(selector);
        }
        else {
            var self_2 = this;
            toolbox._.forEach(this._flowEntities, function (entityData) {
                var selector = entityData.entitySelector;
                if (selector !== self_2._entitySelector) {
                    self_2._entityContainer.append('<div id="' + selector.substring(1) + '"></div>');
                    entityData.entityContainer = toolbox.$(entityData.entitySelector);
                }
            });
        }
    };
    BaseControllerToolbox.prototype.setAdditionalContainer = function (selector, externalId) {
        this._entitySelector += ', ' + selector;
        var $additionalContainer = toolbox.$(selector);
        $additionalContainer.addClass('finance-aside');
        $additionalContainer.append("<div id=\"".concat(externalId, "\"></div>"));
        this._entityContainer = this._entityContainer.add($additionalContainer);
    };
    /**
     * @desc set additional options per flow (may be only market RU)
     * @param {Object} [options=null] options - additional options
     */
    BaseControllerToolbox.prototype.setEntityOptions = function (options) {
        if (options === void 0) { options = null; }
        logger.info('ControllerToolbox => function: setEntityContainer | Params: ', options);
        this._options = options;
    };
    /**
     * @desc set additional options per flow
     * @param {Object} [options=null] options - additional options
     */
    BaseControllerToolbox.prototype.setInitOptions = function (options) {
        if (options === void 0) { options = null; }
        logger.info('ControllerToolbox => function: setInitOptions | Params: ', options);
        this._initOptions = options;
    };
    /**
     * @desc publish tagging events for loaded and closing simulator
     * @param {string} entityId
     * @param {string} eventName
     * @private
     */
    BaseControllerToolbox.prototype._publishTaggingEvent = function (entityId, eventName) {
        var _a, _b;
        logger.info('ControllerToolbox => function: _publishTaggingEvent | Params: ', entityId, eventName);
        eventName +=
            this._entityCounter !== 1 || !this._isSimulator(entityId)
                ? '_' + entityId
                : '';
        if (this._simulatorErrorTemplateLoaded !== true) {
            var eventObjParams = {
                throwEvent: eventName,
                productId: (_b = (_a = this._flowEntities[entityId]) === null || _a === void 0 ? void 0 : _a.currentProdId) !== null && _b !== void 0 ? _b : 1,
                entityId: entityId,
            };
            this._eventManager.publish(eventName, BASE_PUBLISHER_NAME, eventObjParams);
        }
    };
    /**
     * @desc destroy entity with given id
     * @param {Number} entityId
     * @public
     */
    BaseControllerToolbox.prototype.destroyEntity = function (entityId) {
        var _a, _b, _c, _d, _e;
        logger.info('ControllerToolbox => function: destroyEntity | Params: ', entityId);
        if (this.entityBuilder !== null) {
            if (this.entityBuilder._entityMap.size > 0 &&
                this._flowParams.country === 'ru') {
                this._publishTaggingEvent(entityId, 'simulatorConfirmClosing_' +
                    this.entityBuilder._entityMap.entries().next().value[1]
                        ._entityActiveProductId);
                (_b = (_a = toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[entityId]) === null || _b === void 0 ? void 0 : _b.publish('saveEntity', toolbox.resultDataFlat[toolbox.currentProductId]);
            }
            else if (this.entityBuilder._entityMap.size > 0 &&
                !this._isCloseButton) {
                this._publishTaggingEvent(entityId, 'simulatorClosing_' +
                    this.entityBuilder._entityMap.entries().next().value[1]
                        ._entityActiveProductId);
                (_d = (_c = toolbox.dxpTagging) === null || _c === void 0 ? void 0 : _c[entityId]) === null || _d === void 0 ? void 0 : _d.publish('closeEntity', {
                    entityId: entityId,
                    productId: toolbox.currentProductId,
                    integrationMode: ((_e = this._options) === null || _e === void 0 ? void 0 : _e.integrationMode) || null,
                });
            }
            this.entityBuilder.destroyEntity(entityId);
            if (this._isSimulator(entityId)) {
                this._entityCounter--;
            }
            this._dealerPosInterfaceRequestCanceled = true;
        }
        toolbox.$(this._entitySelector).children().remove();
        if (!this.isCompareFinance)
            toolbox.$(this._entitySelector).removeAttr('style').removeClass();
        this._eventManager.unsubscribeByOwner('bss-create-flow-' +
            this._flowId +
            '-entity-' +
            this._getEntityOrder(entityId));
    };
    /**
     * @desc destroy all entities in the flow
     * @public
     */
    BaseControllerToolbox.prototype.destroyFlow = function (widgetInWidget) {
        var _this = this;
        logger.info('ControllerToolbox => function: destroyFlow');
        toolbox._.forEach(this._flowEntities, function (entityData, entityIndex) {
            _this.destroyEntity(entityIndex);
        });
    };
    /**
     * @desc Set GA to BSSBackendConnector to use it with all request.
     * @param gaKEY
     */
    BaseControllerToolbox.prototype.setGAKey = function (gaKEY) {
        logger.info('ControllerToolbox => function: setGAKey');
        if (!gaKEY) {
            //When no GA KEY we create it. And store in session. On load check if "BSS_QA_KEY" are defined in session.
            if (sessionStorage.getItem('BSS_GA_KEY')) {
                gaKEY = sessionStorage.getItem('BSS_GA_KEY');
            }
            else {
                gaKEY = this._BSSBackendConnector.keyGenerator();
                sessionStorage.setItem('BSS_GA_KEY', gaKEY);
            }
        }
        this._BSSBackendConnector.setGAKey(gaKEY);
    };
    /**
     * Escape string, preventing for Cross Site Scripting.
     * @param value
     * @returns {String}
     */
    BaseControllerToolbox.prototype.ecs = function (value) {
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    };
    return BaseControllerToolbox;
}());
export { BaseControllerToolbox };
